// @ts-nocheck
import { findClosestPoints, findLinesIntersection, findRectangleAndLineIntersectionPoints, getLineSelectBoundary, getProjection, getSideOfMouseRelativeToLine, isPointInsideFrame, isinSelectBoundaryLine, pointInsideRectangle, transformPointByMatrix3 } from "../../shared/common";
import { BasicShape } from "../BasicShape";
import { Point } from "../Point";
import { mat3 } from "gl-matrix";


import { s } from "../../shared/globalState/settings";
import { Join } from "../Join";
import { ObjectTypes } from "../../shared/enums";
import { RouteCrucialPoints } from "../../shared/types";

export class Guide extends BasicShape {

    private _start: Point;
    mid: Point;
    private _end: Point;
    private _isSelected: boolean;
    type: string;
    color: number[];
    thickness: number;
    startJ: Join;
    endJ: Join;
    routeId: string;

    get start(): Point {
        return this._start;
    }
    set start(point) {
        this._start = point.clone();
        this.mid = this.getMid(this.start, this.end);
        // ********* обновление сохранённых вершин **********
        // this.saved = this.getVertices();
    }
    get end(): Point {
        return this._end;
    }
    set end(point) {
        this._end = point.clone();
        this.mid = this.getMid(this.start, this.end);
        // ********* обновление сохранённых вершин **********
        // this.saved = this.getVertices();

    }

    get isSelected(): boolean {
        this._isSelected = false;
        return this._isSelected;
    }
    set isSelected(value) {
        this._isSelected = false;
    }

    constructor(start: Point, end: Point, color: number[], thickness: number) {
        super();
        this._isSelected = false;
        this.type = 'guide';
        // Store real Point instances so that downstream geometry utilities
        // (e.g. Vector) can safely rely on Point methods like clone().
        this._start = start ? start.clone() : Point.ORIGIN.clone();
        this._end = end ? end.clone() : Point.ORIGIN.clone();
        this.mid = this.getMid(this._start, this._end);
        this.color = s.guideColor;
        this.thickness = 1;

        this.startJ = new Join(this._start, this.id);
        this.endJ = new Join(this._end, this.id);

    }


    getMid(start, end) {
        const midX = (start.x + end.x) / 2;
        const midY = (start.y + end.y) / 2;
        return new Point(midX, midY);
    }


    getVertices() {
        return new Float32Array(this.getTriangulatedVertices());
    }
    getVerticesArray() {
        return [
            this.start.x, this.start.y,
            this.end.x, this.end.y,
        ];
    }

    getTriangulatedVertices() {

        let start = this.start.clone();
        let end = this.end.clone();
        let width = this.thickness;
        // Calculate the vector along the line segment
        let dx = end.x - start.x;
        let dy = end.y - start.y;

        // Calculate the normalized perpendicular vector
        let length = Math.hypot(dx, dy);
        let nx = dy / length;  // Normalized perpendicular vector x
        let ny = -dx / length; // Normalized perpendicular vector y

        // Calculate the offset points for the rectangle corners
        let offsetX = nx * width / 2;
        let offsetY = ny * width / 2;

        // Calculate the four corners of the rectangle
        let corner1 = { x: start.x + offsetX, y: start.y + offsetY };
        let corner2 = { x: end.x + offsetX, y: end.y + offsetY };
        let corner3 = { x: end.x - offsetX, y: end.y - offsetY };
        let corner4 = { x: start.x - offsetX, y: start.y - offsetY };

        // Return the coordinates of the rectangle corners as two triangles
        return [
            corner1.x, corner1.y,
            corner2.x, corner2.y,
            corner3.x, corner3.y,
            corner1.x, corner1.y,
            corner3.x, corner3.y,
            corner4.x, corner4.y
        ];



    }



    /**
     * Эта функция нужна для получения нормалей с помощью библиотеки polyline-normals - она в качестве аргумента принимает массив вот такого вида
     */
    getPath() {
        return [
            [this.start.x, this.start.y],
            [this.end.x, this.end.y]
        ]
    }


    getClone() {
        const guide = new Guide(this.start, this.end, this.color, this.thickness);

        guide.rtype = this.rtype;

        guide.routeId = this.routeId;
        guide.startJ.id = this.startJ.id;
        guide.endJ.id = this.endJ.id;

        // ********* обновление сохранённых вершин *********
        // line.saved = this.getVertices();
        return guide;
    }

    isinSelectFrame(frame) {
        const angle = Math.atan2(this.end.y - this.start.y, this.end.x - this.start.x);
        const offsetX = s.tolerance * Math.sin(angle);
        const offsetY = s.tolerance * Math.cos(angle);
        const point1 = new Point(this.start.x - offsetX, this.start.y + offsetY);
        const point2 = new Point(this.end.x - offsetX, this.end.y + offsetY);
        const point3 = new Point(this.end.x + offsetX, this.end.y - offsetY);
        const point4 = new Point(this.start.x + offsetX, this.start.y - offsetY);
        if (
            isPointInsideFrame(frame, point1.x, point1.y) &&
            isPointInsideFrame(frame, point2.x, point2.y) &&
            isPointInsideFrame(frame, point3.x, point3.y) &&
            isPointInsideFrame(frame, point4.x, point4.y)
        ) {
            return true;
        }

        return false;
    }
    iscrossSelectFrame(frame) {

        let xcross1 = findLinesIntersection(this, frame.vec.getOrtho1X());
        let ycross1 = findLinesIntersection(this, frame.vec.getOrtho1Y());
        let xcross2 = findLinesIntersection(this, frame.vec.getOrtho2X());
        let ycross2 = findLinesIntersection(this, frame.vec.getOrtho2Y());
        if (xcross1 || ycross1 || xcross2 || ycross2) {
            return true;
        }
        return false;
        
    }
    isinSelectFrameAtLeast(frame) {
        // const angle = Math.atan2(this.end.y - this.start.y, this.end.x - this.start.x);
        // const offsetX = s.tolerance * Math.sin(angle);
        // const offsetY = s.tolerance * Math.cos(angle);
        // const point1 = new Point(this.start.x - offsetX, this.start.y + offsetY);
        // const point2 = new Point(this.end.x - offsetX, this.end.y + offsetY);
        // const point3 = new Point(this.end.x + offsetX, this.end.y - offsetY);
        // const point4 = new Point(this.start.x + offsetX, this.start.y - offsetY);
        // if (
        //     isPointInsideFrame(frame, point1.x, point1.y) ||
        //     isPointInsideFrame(frame, point2.x, point2.y) ||
        //     isPointInsideFrame(frame, point3.x, point3.y) ||
        //     isPointInsideFrame(frame, point4.x, point4.y)
        // ) {
        //     return true;
        // }

        // return false;

        // новый способ - false возвращается только в том случае, если линия целиком находится за границами frame
        var isinFrame = this.isinSelectFrame(frame);
        
        var vec1 = frame.vec.getOrtho1X();
        var vec2 = frame.vec.getOrtho2X();
        var vec3 = frame.vec.getOrtho1Y();
        var vec4 = frame.vec.getOrtho2Y();

        var crossx1 = findLinesIntersection(this, vec1);
        var crossx2 = findLinesIntersection(this, vec2);
        var crossy1 = findLinesIntersection(this, vec3);
        var crossy2 = findLinesIntersection(this, vec4);
        
        if (crossx1 || crossx2 || crossy1 || crossy2 || isinFrame) {
            return true;
        }
        return false;

        
    }

    isinSelectBoundary(mouse) {
        return isinSelectBoundaryLine(mouse, this.start, this.end);
    }

    setSelectBoundary() {

        this.selectBoundary = getLineSelectBoundary(this.start, this.end);
    }
    // --------- MAGNETS ---------
    isinGripStart = (mouse) => this.grip.isin(this.start, mouse);
    isinGripEnd = (mouse) => this.grip.isin(this.end, mouse);
    isinGripMid = (mouse) => this.grip.isin(this.mid, mouse);
    isinTripHstart = (mouse) => this.tripH.isin(this.start, mouse);
    isinTripHmid = (mouse) => this.tripH.isin(this.mid, mouse);
    isinTripHend = (mouse) => this.tripH.isin(this.end, mouse);
    isinTripVstart = (mouse) => this.tripV.isin(this.start, mouse);
    isinTripVmid = (mouse) => this.tripV.isin(this.mid, mouse);
    isinTripVend = (mouse) => this.tripV.isin(this.end, mouse);
    // --------- MAGENTS ---------


    zoom(zl) {
        const zoom_mat = mat3.fromScaling(mat3.create(), [zl, zl]);
        this.start = transformPointByMatrix3(zoom_mat, this.start);
        this.mid = transformPointByMatrix3(zoom_mat, this.mid);
        this.end = transformPointByMatrix3(zoom_mat, this.end);
        // s.tolerance = s.tolerance * zl;
    }

    pan(tx, ty) {
        const pan_mat = mat3.fromTranslation(mat3.create(), [tx, ty]);
        mat3.transpose(pan_mat, pan_mat);
        this.start = transformPointByMatrix3(pan_mat, this.start);
        this.mid = transformPointByMatrix3(pan_mat, this.mid);
        this.end = transformPointByMatrix3(pan_mat, this.end);
    }
    /**
     * Функция возвращает две точки пересечения, если текущая линия пересекается с другими фигурами.
     * Особенность функции в том, что сначала проверяются все круги, и если точки пересечения найдены, происходит возврат из функции - результат получен.
     * Если точки пересечения с кругами не найдены, таким же образом проверяются все прямоугольники, и также, если точки найдены - возврат из функции.
     * Далее, если ни с кругами, ни с прямоугольниками текущая линия не пересекается, проверяются линии.
     */
    getBreakPoints(mouse, shapes_) {
        let bs, be
        const shapesCircle = shapes_.filter(shape => shape.type === ObjectTypes.circle);
        const shapesLine = shapes_.filter(shape => shape.type === ObjectTypes.line);
        const shapesRectangle = shapes_.filter(shape => shape.type === ObjectTypes.rectangle);

        for (const shape of shapesCircle) {
            if (this.isinCircle(shape, mouse)) {
                const intersectionPoints = this.findCircleLineIntersections(shape, this);
                if (intersectionPoints.length > 0) {
                    if (intersectionPoints.length === 1) {
                        bs = intersectionPoints[0];
                        be = null;
                    }
                    else {
                        for (let point of intersectionPoints) {
                            if (!bs) {
                                bs = point;
                            } else {
                                be = point;
                            }

                        }
                    }

                }
                else {
                    continue;
                }

                return { bs, be }; // Return immediately if circle condition is met

            }
        }
        for (const shape of shapesRectangle) {
            if (this.isinRectangle(shape, mouse)) {
                let intercections = findRectangleAndLineIntersectionPoints(shape.p1, shape.p2, shape.p3, shape.p4, this.start, this.end);
                if (intercections.length > 0) {
                    if (intercections.length === 1) {
                        bs = intercections[0];
                        be = null;
                    }
                    else {
                        for (let point of intercections) {
                            if (!bs) {
                                bs = point;
                            } else {
                                be = point;
                            }
                        }
                    }
                }
                else {
                    continue;
                }
                return { bs, be }; // Return immediately if rectangle condition is met
            }
        }

        let closest = this.findClosest(mouse, shapesLine);
        if (closest.length === 0) {
            return { bs: null, be: null };
        }
        if (closest.length === 1) {
            return { bs: closest[0], be: null }
        }
        else {
            return { bs: closest[0], be: closest[1] }
        }


    }

    isinCircle(circle, point) {
        const dx = point.x - circle.center.x;
        const dy = point.y - circle.center.y;
        return dx * dx + dy * dy < circle.radius * circle.radius;
    }
    /**
     * Функция проверяет, находится ли мышь внутри прямоугольника
     */
        isinRectangle(rectangle, mouse) {
        var [p1, p2, p3, p4] = rectangle.getPoints();
        return pointInsideRectangle(mouse, p1, p2, p3, p4);
    }



    findIntersectionPoint(selectedLine, line2) {
        const x1 = selectedLine.start.x;
        const y1 = selectedLine.start.y;
        const x2 = selectedLine.end.x;
        const y2 = selectedLine.end.y;

        const x3 = line2.start.x;
        const y3 = line2.start.y;
        const x4 = line2.end.x;
        const y4 = line2.end.y;


        const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);

        if (denominator === 0) {
            return null; // Lines are parallel or coincident
        }

        const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
        const ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

        if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
            const x = x1 + ua * (x2 - x1);
            const y = y1 + ua * (y2 - y1);
            return new Point(x, y);
        } else {
            return null; // Intersection point is outside the line segments
        }
    }




    findCircleLineIntersections(circle, line) {
        const circleCenter = circle.center;

        const circleRadius = circle.radius;

        const dx = line.end.x - line.start.x;
        const dy = line.end.y - line.start.y;

        const a = dx * dx + dy * dy;
        const b = 2 * (dx * (line.start.x - circleCenter.x) + dy * (line.start.y - circleCenter.y));
        const c = circleCenter.x * circleCenter.x + circleCenter.y * circleCenter.y + line.start.x * line.start.x + line.start.y * line.start.y - 2 * (circleCenter.x * line.start.x + circleCenter.y * line.start.y) - circleRadius * circleRadius;

        const discriminant = b * b - 4 * a * c;

        if (discriminant < 0) {
            return []; // No intersection, return empty array
        } else {
            // Two intersection points
            const t1 = (-b + Math.sqrt(discriminant)) / (2 * a);
            const t2 = (-b - Math.sqrt(discriminant)) / (2 * a);
            const intersection1 = new Point(line.start.x + t1 * dx, line.start.y + t1 * dy);
            const intersection2 = new Point(line.start.x + t2 * dx, line.start.y + t2 * dy);
            if (this.isinCircle(circle, line.start) || this.isinCircle(circle, line.end)) {
                if (this.isinCircle(circle, line.start)) {
                    const side = getSideOfMouseRelativeToLine(line.start, intersection1, line);
                    if (side === 'start') {
                        return [intersection1];
                    }
                    else {
                        return [intersection2];
                    }

                }
                else if (this.isinCircle(circle, line.end)) {
                    const side = getSideOfMouseRelativeToLine(line.end, intersection1, line);
                    if (side === 'start') {
                        return [intersection1];
                    }
                    else {
                        return [intersection2];
                    }
                }
            }
            else {
                return [intersection1, intersection2];

            }
        }
    }


    doLinesIntersect(line1, line2) {
        const x1 = line1.start.x;
        const y1 = line1.start.y;
        const x2 = line1.end.x;
        const y2 = line1.end.y;

        const x3 = line2.start.x;
        const y3 = line2.start.y;
        const x4 = line2.end.x;
        const y4 = line2.end.y;

        const denominator = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
        if (denominator === 0) {
            return false; // Lines are parallel
        }

        const ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
        const ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

        return ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1;
    }

    findClosest(mouse, shapes) {
        const mouseProjection = getProjection(mouse, this as any);
        const intersections = shapes.map(shape => {
            return this.findIntersectionPoint(this as any, shape);
        }).filter(item => item);
        const closestPoints = findClosestPoints(mouseProjection, intersections);
        return closestPoints;
    }

    calculateDistance(mouse, line) {
        const result = Math.hypot(mouse.x - line.start.x, mouse.y - line.start.y)
        return result;
    }

    isEqual(anotherLine) {
        if (this.start.equals(anotherLine.start) && this.end.equals(anotherLine.end)) {
            return true;
        }
        return false;
    }

    getLength() {
        const dx = this.end.x - this.start.x;
        const dy = this.end.y - this.start.y;
        return Math.sqrt(dx * dx + dy * dy);
    }
    
    public getCrucialPoints(): RouteCrucialPoints {
        throw new Error("Method not implemented.");
    }


}